function NodeLabel(props: {  disabled?: boolean, placeholder: string, value: string, height: number, onChange: (text: string) => void }) {
  return (
    <input
      type='text'
      className='node-label'
      style={{
        color: props.disabled ? "#fff" : "#030303 !important",
        fontSize: `${props.height * 0.1}px`,
        fontWeight: 700
      }}
      disabled={props.disabled}
      value={props.value}
      placeholder={props.placeholder}
      onChange={(evt) => props.onChange(evt.target.value)} />
  );
}

export default NodeLabel;
